import Vue from 'vue';
import initialState from './defaultState';

export default {
    resetStateMutation(state) {
        const defaultState = initialState();

        Object.keys(state).forEach(item => {
            Vue.set(state, item, defaultState[item]);
        })
    },
    setFormOpen(state) {
        state.appointmentStatusFormIsOpen = true;
        state.appointmentStatusGridIsOpen = false;
    },
    setFormClose(state) {
        state.appointmentStatusFormIsOpen = false;
        state.appointmentStatusGridIsOpen = true;
    },
}
